import React, { useRef } from 'react';
import { Row, Switch } from 'antd';
import PropTypes from 'prop-types';

import DeleteIcon from 'components/Icons/DeleteIcon';
import './ControllerWrapper.scss';
import { EditIcon2 } from 'components/Icons';

const ControllerWrapper = ({
  children,
  onRequiredChange,
  isRequired,
  onEdit,
  onDelete,
  showEdit = true,
  showDelete = true,
  showRequired = true,
  ...props
}) => {
  const componentWrapperRef = useRef();

  return (
    <div className={`controller-wrapper`} ref={componentWrapperRef} {...props}>
      {children}
      <div className="action-buttons-wrapper">
        {(showEdit || showDelete || showRequired) && (
          <div>
            {showEdit && (
              <Row className="edit-action" onClick={onEdit}>
                <EditIcon2 />
                <span>Edit</span>
              </Row>
            )}
            {showDelete && <div className="divider"></div>}
            {showDelete && <DeleteIcon className="delete-icon" onClick={onDelete} />}
          </div>
        )}
        {showRequired && (
          <Row>
            {showRequired && (
              <>
                <Switch size="small" checked={isRequired} onChange={onRequiredChange} />
                <span>Required field</span>
              </>
            )}
          </Row>
        )}
      </div>
    </div>
  );
};

ControllerWrapper.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ControllerWrapper;
